import './FixedBottomNavbar.scss';
import Navbar from 'react-bootstrap/Navbar';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row'
import React, { ReactNode } from 'react';

export interface FixedBottomNavbarProps {
  children: ReactNode
}

export default function FixedBottomNavbar({ children }: FixedBottomNavbarProps) {
  return <Navbar fixed="bottom" bg="secondary" className="container-xl rounded-top">
    <Row className="navbar-inside-center">
      {React.Children.map(children, child => <Col md={true} className="navbar-inside-center d-flex px-3">{child}</Col>)}
    </Row>
  </Navbar>;
}
